import './Filter.scss';
import React, { useState } from 'react';
import {
    GET_ALL_LOFAS,
    GET_ALL_DRIVERS_FILTER,
    GET_ALL_CARRIERS_FILTER,
    GET_ALL_PROPPANTS,
    GET_JOB_FILTERS_LIST,
    GET_ALL_JOBS_FILTER,
    GET_ALL_STATUS_FILTER,
    GET_ALL_REGIONS,
} from '../../graphql/client/queries';
import {
    GetAllLofas,
    GetAllDriversFilter,
    GetAllCarriersFilter,
    GetAllProppants,
    GetJobFiltersList,
    GetAllJobsFilter,
    GetAllStatusFilter,
    GetAllRegions,
} from '../../types/schemaTypes';
import { useStoreContext } from '../App/StoreProvider';
import LoadFilterItem from './FilterItem/LoadFilterItem';
import Button from 'react-bootstrap/Button';
import { useQuery } from '@apollo/client/react';
import DatePickerFilterItem from './DatePickerFilterItem/DatePickerFilterItem';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface LoadFiltersProps {
    abortRequest: () => void;
    onFilterToggle: () => void;
    showFilter: boolean;
    setShowFilter: React.Dispatch<React.SetStateAction<boolean>>;
}

export const LoadFilters = ({
    abortRequest,
    onFilterToggle,
    showFilter,
    setShowFilter,
}: LoadFiltersProps): React.ReactElement => {
    const [activeKey, setActiveKey] = useState('0');
    const [state] = useStoreContext();

    const { data: lofasData } = useQuery<GetAllLofas>(GET_ALL_LOFAS);
    const { data: driversData } = useQuery<GetAllDriversFilter>(GET_ALL_DRIVERS_FILTER);
    const { data: carriersData } = useQuery<GetAllCarriersFilter>(GET_ALL_CARRIERS_FILTER);
    const { data: proppantsData } = useQuery<GetAllProppants>(GET_ALL_PROPPANTS);
    const { data: jobFiltersData } = useQuery<GetJobFiltersList>(GET_JOB_FILTERS_LIST);
    const { data: jobData } = useQuery<GetAllJobsFilter>(GET_ALL_JOBS_FILTER);
    const { data: loadStatusesData } = useQuery<GetAllStatusFilter>(GET_ALL_STATUS_FILTER);
    const { data: regionsData } = useQuery<GetAllRegions>(GET_ALL_REGIONS);

    let jobStatuses: any = [];
    const proppants: any = [];
    const lofaFilters: any = [];
    let driverFilters: any = [];
    let carrierFilters: any = [];
    let loadStatuses: any = [];
    const districtFilters: any = [];
    const regionFilters: any = [];
    let customerFilters: any = [];
    let allJobsFilters: any = [];

    const {
        loadManagementList: {
            searchPhraseSubset: {
                jobSubset,
                regionSubset,
                districtSubset,
                customerSubset,
                jobStatusSubset,
                carrierSubset,
                statusSubset,
                proppantSubset,
                lofaSubset,
                driverSubset,
            },
            filters: { fromDate, toDate },
        },
    } = state;

    if (lofasData && lofasData.getAllLofas) {
        lofasData.getAllLofas.forEach((item: any) => {
            lofaFilters.push({
                id: item.lofaId,
                name: item.lofaName,
            });
        });
    }

    if (driversData && driversData.getAllDriversFilter) {
        driverFilters = driversData.getAllDriversFilter;
    }

    if (carriersData && carriersData.getAllCarriersFilter) {
        carrierFilters = carriersData.getAllCarriersFilter;
    }

    if (proppantsData && proppantsData.getAllProppants) {
        proppantsData.getAllProppants.forEach((item: any) => {
            proppants.push({
                id: item.proppantId,
                name: item.proppantName,
            });
        });
    }

    if (jobFiltersData && jobFiltersData.getJobFiltersList) {
        if (jobFiltersData.getJobFiltersList.statuses) {
            jobStatuses = jobFiltersData.getJobFiltersList.statuses;
        }
        if (jobFiltersData.getJobFiltersList.customers) {
            customerFilters = jobFiltersData.getJobFiltersList.customers;
        }
    }

    if (jobData && jobData.getAllJobsFilter) {
        allJobsFilters = jobData.getAllJobsFilter;
    }

    if (loadStatusesData && loadStatusesData.getAllStatusFilter) {
        
        loadStatuses = [...loadStatusesData.getAllStatusFilter];
        
        // Remove the UNKNOWN status from the statuses list
        loadStatuses = loadStatuses.filter((stat: any) => {
            return stat?.name !== 'Unknown';
        });
        const copyLoadStatus : any = [];
        loadStatuses.forEach((ele)=>{
            const copy = {...ele};
            if (copy?.name == 'Created'){
                copy.name = 'Created/Rejected'; 
            }
            copyLoadStatus.push(copy);
        });
        loadStatuses = copyLoadStatus;
    }

    if (regionsData && regionsData.getAllRegions) {
        regionsData.getAllRegions.forEach((item: any) => {
            regionFilters.push({
                id: item.id,
                name: item.regionName,
            });

            item.districts.forEach((district: any) => {
                districtFilters.push({
                    id: district.id,
                    name: district.districtName,
                });
            });
        });
    }

    return (
        <div
            id="MessagesFilterContainer"
            className={showFilter ? 'JobLoads-FiltersContainer' : 'JobLoads-FiltersContainer hide'}
        >
            <div className="Filter-Container">
                <div className="Filter-Header">
                    <div className="Filter-HeaderIconContainer">
                        <i className="material-icons">filter_list</i>
                        <span className="Filter-HeaderTitle">Filters</span>
                    </div>
                    <Button
                        className="Filter-SelectAll"
                        variant="link"
                        onClick={(): void => setActiveKey(activeKey === '0' ? '1' : '0')}
                    >
                        {activeKey === '0' ? 'Collapse All' : 'Expand All'}
                    </Button>
                    <FontAwesomeIcon
                        icon={['fas', 'times-circle']}
                        className="JobLoads-Filter"
                        onClick={() => setShowFilter(!showFilter)}
                    />
                </div>

                <div className="Filter-Body">
                    <LoadFilterItem
                        abortRequest={abortRequest}
                        title="Load Status"
                        items={loadStatuses}
                        itemsSubset={statusSubset.subset}
                        searchPhrase={statusSubset.searchPhrase}
                        activeKey={activeKey}
                        isCollection={true}
                        isSearchable={false}
                        loadManagementMode={true}
                        onFilterToggle={onFilterToggle}
                    />
                    <LoadFilterItem
                        abortRequest={abortRequest}
                        title="Customer"
                        items={customerFilters}
                        itemsSubset={customerSubset.subset}
                        searchPhrase={customerSubset.searchPhrase}
                        activeKey={activeKey}
                        isCollection={true}
                        isSearchable={true}
                        loadManagementMode={true}
                        onFilterToggle={onFilterToggle}
                    />
                    <LoadFilterItem
                        abortRequest={abortRequest}
                        title="Region"
                        items={regionFilters}
                        itemsSubset={regionSubset.subset}
                        searchPhrase={regionSubset.searchPhrase}
                        activeKey={activeKey}
                        isCollection={true}
                        isSearchable={true}
                        loadManagementMode={true}
                        onFilterToggle={onFilterToggle}
                    />
                    <LoadFilterItem
                        abortRequest={abortRequest}
                        title="District"
                        items={districtFilters}
                        itemsSubset={districtSubset.subset}
                        searchPhrase={districtSubset.searchPhrase}
                        activeKey={activeKey}
                        isCollection={true}
                        isSearchable={true}
                        loadManagementMode={true}
                        onFilterToggle={onFilterToggle}
                    />
                    <DatePickerFilterItem
                        abortRequest={abortRequest}
                        title="Delivered Date"
                        activeKey={activeKey}
                        fromDate={fromDate}
                        toDate={toDate}
                        filterType="Load"
                        closeDateRange={() => {}}
                    />
                    <LoadFilterItem
                        abortRequest={abortRequest}
                        title="Job"
                        items={allJobsFilters}
                        itemsSubset={jobSubset.subset}
                        searchPhrase={jobSubset.searchPhrase}
                        activeKey={activeKey}
                        isCollection={true}
                        isSearchable={true}
                        loadManagementMode={true}
                        onFilterToggle={onFilterToggle}
                    />
                    <LoadFilterItem
                        abortRequest={abortRequest}
                        title="Job Status"
                        items={jobStatuses}
                        itemsSubset={jobStatusSubset.subset}
                        searchPhrase={jobStatusSubset.searchPhrase}
                        activeKey={activeKey}
                        isCollection={true}
                        isSearchable={false}
                        loadManagementMode={true}
                        onFilterToggle={onFilterToggle}
                    />
                    <LoadFilterItem
                        abortRequest={abortRequest}
                        title="Loading Facility"
                        items={lofaFilters}
                        itemsSubset={lofaSubset.subset}
                        searchPhrase={lofaSubset.searchPhrase}
                        activeKey={activeKey}
                        isCollection={true}
                        isSearchable={true}
                        loadManagementMode={true}
                        onFilterToggle={onFilterToggle}
                    />
                    <LoadFilterItem
                        abortRequest={abortRequest}
                        title="Proppant"
                        items={proppants}
                        itemsSubset={proppantSubset.subset}
                        searchPhrase={proppantSubset.searchPhrase}
                        activeKey={activeKey}
                        isCollection={true}
                        isSearchable={true}
                        loadManagementMode={true}
                        onFilterToggle={onFilterToggle}
                    />
                    <LoadFilterItem
                        abortRequest={abortRequest}
                        title="Driver"
                        items={driverFilters}
                        itemsSubset={driverSubset.subset}
                        searchPhrase={driverSubset.searchPhrase}
                        activeKey={activeKey}
                        isCollection={true}
                        isSearchable={true}
                        loadManagementMode={true}
                        onFilterToggle={onFilterToggle}
                    />
                    <LoadFilterItem
                        abortRequest={abortRequest}
                        title="Carrier"
                        items={carrierFilters}
                        itemsSubset={carrierSubset.subset}
                        searchPhrase={carrierSubset.searchPhrase}
                        activeKey={activeKey}
                        isCollection={true}
                        isSearchable={true}
                        loadManagementMode={true}
                        onFilterToggle={onFilterToggle}
                    />
                </div>
            </div>
        </div>
    );
};
